// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"046791ce","156":"097d0179","341":"d04918e4","438":"39bbd81a","706":"4f63bcbb","726":"1f034d7b"}[chunkId] + ".chunk.js";
};